import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  nextStep: {
    defaultMessage: 'Authenticate with {providerName} in the next step.',
    id: 'ProviderBanner.nextStep',
  },
});
